import React from 'react';

import { bemBlock } from '../../modules/bem';
import { Text } from '../text/Text';

import { useEmblemContext } from './EmblemContext';

import './EmblemText.less';

const block = bemBlock('n-emblem-text');

export type EmblemTextProps = {
  disableNativeTooltip?: boolean;
};

export const EmblemText: React.FC<EmblemTextProps> = ({ disableNativeTooltip, children }) => {
  const { size, active } = useEmblemContext();

  const cssClass = block({ modifiers: { size, active } });

  const title = !disableNativeTooltip && typeof children === 'string' ? children : undefined;

  return (
    <Text className={cssClass} ellipsis title={title}>
      {children}
    </Text>
  );
};
